import { watch } from 'vue';
import { useUrlHistoryStore } from '@/store/urlHistoryStore';
import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';

export default function useProviderWatcher() {
  const urlHistoryStore = useUrlHistoryStore();
  const urlSourcesStore = useUrlSourcesStore();
  const activeUrlStore = useActiveUrlStore();

  // Watch for provider changes from the homepage
  watch(
    () => urlSourcesStore.getHomepageProvider,
    (newProvider) => {
      if (newProvider !== undefined && activeUrlStore.activeUrl) {
        urlHistoryStore.updateProvider(activeUrlStore.activeUrl, newProvider);
      }
    }
  );
}
